export default (schema) => {
  const validSchema = schema && schema.toString().replace(/[^a-zA-Z ]/g, '').toLowerCase();
  return validSchema;
};
